// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__8V9Ho","tag--transparent":"Tag_tag--transparent__F+lX3","tag--default":"Tag_tag--default__y9oTc","tag__close":"Tag_tag__close__HoeCB","link":"Tag_link__6-cmg"};